import { template as template_f8de26a3aa044ea891165c115b2c99e9 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/file-extract';
const { stringify } = JSON;
export default RouteTemplate(template_f8de26a3aa044ea891165c115b2c99e9(`
  <div
    data-prerender-file-extract
    data-prerender-file-extract-id={{@model.id}}
    data-prerender-file-extract-nonce={{@model.nonce}}
    data-prerender-file-extract-status={{@model.status}}
  >
    <pre>{{stringify @model null 2}}</pre>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
